<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "monthTicketId": 507
            },
            responseCode: {
                "data": {
                    "monthTicketId": 11
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询线上月票",
                t_url: this.commonUrls.test + "getOnlineVipTicket",
                p_url: this.commonUrls.prod + "getOnlineVipTicket",
                precondition: "无",
                fitSystem: "云停车场,传统停车场(线上接口开通)",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketId', info2: '是', info3: 'Long', info4: '月票id' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '月票流水号' },
                        { info1: 'userName', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '车主电话' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号，支持多个逗号分隔,展示用' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价' },
                        { info1: 'totalValue', info2: '是', info3: 'Decimal', info4: '总金额' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'refundValue', info2: '是', info3: 'Decimal', info4: '退款金额' },
                        { info1: 'endRenewTime', info2: '否', info3: 'String', info4: '车主截止续费时间' },
                        { info1: 'validStatus', info2: '否', info3: 'Integer', info4: '付款状态，0已付款，1已退款' },
                        { info1: 'createBy', info2: '是', info3: 'String', info4: '创建人' },
                        { info1: 'createTime', info2: '否', info3: 'String', info4: '创建时间/购买时间' },
                        { info1: 'updateBy', info2: '否', info3: 'String', info4: '修改操作人' },
                        { info1: 'updateTime', info2: '否', info3: 'String', info4: '修改操作时间' },
                        { info1: 'inviteCarCurrentCount', info2: '否', info3: 'Integer', info4: '邀请车牌总数量' },
                        { info1: 'dynamicCarportNumber', info2: '否', info3: 'Integer', info4: '该月票开通多少车位' },
                        { info1: 'carCodeNum', info2: '否', info3: 'Integer', info4: '该月票开通的车牌数量' },
                        { info1: 'isDelete', info2: '否', info3: 'Integer', info4: '是否删除, 0 否, 1 是' },
                        { info1: 'buyMethod', info2: '否', info3: 'Integer', info4: '月票购买方式（0:后台添加;1:自行购买;2:第三方添加）' },
                        { info1: 'buyMethodName', info2: '否', info3: 'String', info4: '月票购买方式名称（例如：后台添加;自行购买;第三方添加）' },
                        { info1: 'isFrozen', info2: '是', info3: 'Integer', info4: '是否冻结，0：否，1即将冻结，2冻结' },
                        { info1: 'frozenTime', info2: '否', info3: 'String', info4: '冻结时间' },
                        { info1: 'resendNum', info2: '否', info3: 'Integer', info4: '重发次数' },
                        { info1: 'syncStatus', info2: '否', info3: 'Integer', info4: '同步状态(0未发送，1发送中，2发送成功，3发送失败)' },
                        { info1: 'syncTime', info2: '否', info3: 'String', info4: '同步时间' },
                        { info1: 'syncTime', info2: '否', info3: 'String', info4: '同步时间' },
                        { info1: 'timePeriodList', info2: '否', info3: 'JSONArray', info4: '有效时间段列表' },
                    ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间， yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间， yyyyMMddHHmmss' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getOnlineVipTicket.vue